import * as styles from "./ProgressBar.styles";


interface ProgressBarProps {
  duration: number;
  color?: string;
}


export default function ProgressBar({ duration, color }: ProgressBarProps) {

  return (
    <div css={styles.base}>
      <div css={[
        styles.inner,
        {
          animationDuration: `${duration}s`
        },
        color && {
          backgroundColor: color
        }
      ]} />
    </div>
  );
}
